<script>
export let currentRoute;


import Question from 'components/views/my/faq/elements/Question.svelte';
import Loading from 'components/elements/Loading.svelte';
// import Error from 'components/elements/Error.svelte';



import { auth } from 'store/index.js';


import { get } from 'svelte/store';
import SvelteSeo from 'svelte-seo';



const api_url = app_.env.API_URL;



const token = get(auth).token;



// get last regit



const questions = [
	{
		title: 'How frequently are online registrations updated?',
		text: 'Online (SportsEngine) registrations are updated every 30 minutes.',
	},
	{
		title: 'How frequently are offline registrations updated?',
		text: 'Offline (Non-SportsEngine) registrations are updated on average once every 2-3 days.',
	},
]


</script>


<style>

.hero {
	margin-bottom: 1rem;
}

</style>


<SvelteSeo
	title='Frequently Asked Questions | AHG Coaches Portal'
	description='Frequently Asked Questions!'
/>


<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Frequently Asked Questions
			</p>

		</div>

	</div>

</section>



<section class="section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-8-desktop is-10-tablet is-12-mobile">

				{#each questions as question}

					<Question {question} />

				{/each}

			</div>

		</div>

	</div>

</section>



